import { render, staticRenderFns } from "./ConfigTabCourses.vue?vue&type=template&id=39c764bf"
import script from "./ConfigTabCourses.vue?vue&type=script&lang=js"
export * from "./ConfigTabCourses.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabCourses.vue?vue&type=style&index=0&id=39c764bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports